import { StatusApi } from './StatusApi';
import { get } from 'svelte/store';
import { api } from '../../../stores/api';
import { captureMessage } from '../../utilities/Sentry';
import { app } from '../../../stores/app';

export class MonitorSessionStatus {
    private readonly intervalHandler: any;
    private intervalCheckSeconds: number = 20;

    constructor(onLogout: () => void) {
        this.intervalHandler = setInterval(async () => {
            await StatusApi.check(get(api))
                .then(status => {
                    let frontendCommitHash = get(app).commit_hash;
                    let backendCommitHash = status.commit_hash;
                    if (
                        frontendCommitHash !== backendCommitHash &&
                        backendCommitHash !== null &&
                        frontendCommitHash !== null
                    ) {
                        console.warn('Status check failed, onLogout, commit hash mismatch', {
                            frontendCommitHash,
                            backendCommitHash,
                        });
                        captureMessage('Status check failed, onLogout, commit hash mismatch', {
                            extra: { status, frontendCommitHash, backendCommitHash },
                        });
                    }
                    get(app).session_expires_in_seconds = status.session_expires_in_seconds;
                })
                .catch(error => {
                    console.info('Status check failed, onLogout, timeout', error);
                    onLogout();
                });
        }, this.intervalCheckSeconds * 1000);
    }

    destroy() {
        clearInterval(this.intervalHandler);
    }
}
